import { rem } from 'polished'

export const horizontalPadding = (base: number) => rem(24, base)
export const borderRadius = (base: number) => rem(8, base)
